import React, {useEffect, useState} from 'react';
import {apiGetUserSubjects} from "../ArenaEvents/Actions";
import Widget from "../../components/widget";
import {Form} from "react-final-form";
import SubjectField from "../../FinalForm/api/SubjectField";

const Filter = ({onSubmit, loading, disabled}) => {
    let [showFilter, setShowFilter] = useState(false);

    useEffect(() => {
        getUserSubjects()
    }, []);


    const getUserSubjects = () => {
        apiGetUserSubjects(data => {
            if (data.length === 1) {
                setShowFilter(false)
                onSubmit(data[0].id);
            } else {
                setShowFilter(true)
            }
        }, error => {
        })
    }
    if (!showFilter) return null;
    return (
        <Widget>
            <div className={"flex flex-col"}>
                <Form onSubmit={(values) => onSubmit(values.subjectId)}
                      render={({handleSubmit}) => (
                          <div className={"flex flex-wrap w-full"}>
                              <div className={"w-1/2"}>
                                  <SubjectField disabled={disabled} name={"subjectId"} label={"Vyberte subjekt"} validate={value => !value}
                                                onEnter={() => handleSubmit()} onChange={(e) => {
                                      onSubmit(e?.value ? e.value : null)
                                  }}/>
                              </div>
                          </div>
                      )}/>
            </div>
        </Widget>
    )
}
export default Filter;
